import { participantsTagsConverter } from "@api/models/objects/Converters";
import { Tag } from "@api/models/Tag";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { Store } from "vuex";
export class ParticipantsTagsHelper {

    tags: Tag[] = [];
    parentTags: Tag[] = [];

    constructor(private objectRepository: ObjectRepository, private store: Store<any>) {
    }

    async loadTags() {
        try {

            const profileParams = this.store.getters['events/selectedEventViewParam']('profile', null);

            const settings = profileParams?.tags;
            const tagSchemaId = settings?.collectionId;
            if (!tagSchemaId) { return; }

            const result = await (this.objectRepository).query<Tag[]>(tagSchemaId, {
                take: -1,
                order: [{ column: "orderIndex", direction: "asc" }],
                where: {
                    groupIds: {
                        $containsAnyOrNullOrEmpty: this.store.state.session.profile?.groupIds || []
                    }
                }
            }, participantsTagsConverter);

            const parentIds: string[] = [];

            result.forEach(tag => {
                if(tag.parentId) {
                    this.tags.push(tag);

                    if (!parentIds.includes(tag.parentId)) {
                        parentIds.push(tag.parentId)
                    }
                }
            })

            this.parentTags = result.filter(tag =>parentIds.includes(tag.id))

        }
        catch(error) {
            this.store.dispatch('reportException', error)
        }
    }
}